<template>
    <div class="p-4">
        <div class="p-4 flex flex-column">
            <div class="flex justify-content-center">
                <picture class="flex justify-content-center">
                    <source :srcset="notFoundDarkImage" media="(prefers-color-scheme: dark)" />
                    <img
                        :src="notFoundLightImage"
                        alt="404 page illustration"
                        class="not-found-image"
                    />
                </picture>
            </div>

            <div class="mt-2">
                <div class="flex justify-content-center mt-4">
                    <Button label="Back" severity="contrast" variant="outlined" @click="back()" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import notFoundDarkImage from '@/assets/img/404-dark.svg'
import notFoundLightImage from '@/assets/img/404-light.svg'

const router = useRouter()

const back = () => {
    router.back()
}
</script>
